/**
 * This object contains methods to be used in array methods .
 * @param {string} value - The search value.
 * @param {string} item - The object you are testing against the @value .
 * @param {string} field - The key of the object that you are searching.
 */

export default {
    search: ( value, item, field="name") => item[field].toLowerCase().includes(value.toLowerCase())
}